import type { BaseTranslation } from '../i18n-types';

export const roomClosedReason = {
    userLeft: 'User left the chat',
    youLeft: 'You left the chat',
    userLeftStreamingIssue: 'User left due to the streaming issues',
    youLeftStreamingIssue: 'You left due to the streaming issues',
    userLeftBalance: 'User left due to insufficient balance',
    youLeftBalance: 'You left due to insufficient balance',
    chatClosedNoCameraUser: 'Chat was closed due to the user’s disabled camera',
    chatClosedNoCameraYou: 'Chat was closed due to you disabling your camera',
    chatClosedEngagedUser: 'Chat was closed due to the user being engaged in another call',
    chatClosedEngagedYou: 'Chat was closed due to your engagement in another call',
    chatClosedStreamingIssue: 'Chat was closed due to streaming or playback issue',
    chatClosedViolationRules: 'Chat was closed due to violation of the rules',
    chatClosedInactivity: 'Chat was closed due to inactivity',
    fallback: 'Chat was closed',
} satisfies BaseTranslation;
